import { useCallback, useEffect, useRef, useState } from 'react'

interface UseSingleActivePopoverResult {
    eventName: string
    onClose: () => void
    defaultOpen?: boolean
}

export const useSingleActivePopover = ({ 
    eventName, 
    onClose, 
    defaultOpen = true 
}: UseSingleActivePopoverResult) => {
    const [open, setOpen] = useState(defaultOpen)
    const popoverId = useRef(`popover-${Math.random().toString(36).slice(2)}`)

    useEffect(() => {
        const onActivePopoverChange = (event: Event) => {
            const customEvent = event as CustomEvent<string>
            if (customEvent.detail !== popoverId.current && open) {
                setOpen(false)
                onClose()
            }
        }

        window.addEventListener(eventName, onActivePopoverChange)

        return () => {
            window.removeEventListener(eventName, onActivePopoverChange)
        }
    }, [eventName, onClose, open])

    useEffect(() => {
        if(open) {
            window.dispatchEvent(new CustomEvent<string>(eventName, { detail: popoverId.current }))
        }
    }, [eventName, open])

    const handleOpenChange = useCallback((next: boolean) => {
        setOpen(next)
        if (!next) {
            onClose()
        }
    }, [onClose])

    return { open, setOpen, handleOpenChange }
}